const FILEPOND = {
    onReady() {
        FILEPOND.build();
    },
    build() {
        const elements = document.querySelectorAll('.filepond:not(.assigned)');
        FilePond.registerPlugin(
            FilePondPluginFileEncode,
            FilePondPluginFileValidateSize,
            FilePondPluginFileValidateType
        );
        elements.forEach(element => {
            element.classList.add('assigned');
            FilePond.create(element, {
                labelIdle: 'Profil hochladen',
                labelInvalidField: 'Feld beinhaltet nicht unterstützte Dateien',
                labelFileWaitingForSize: 'Ermittelt die Dateigröße...',
                labelFileSizeNotAvailable: 'Größe nicht vorhanden',
                labelFileLoading: 'Lädt...',
                labelFileLoadError: 'Fehler während des Ladens',
                labelFileProcessingComplete: 'Upload erfolgreich',
                labelFileProcessingAborted: 'Upload abgebrochen',
                labelFileProcessingError: 'Fehler während des Uploads',
                labelTapToCancel: 'Tap für Abbruch',
                labelTapToRetry: 'Tap zum Wiederholen',
                labelTapToUndo: 'Tap zum rückgängig machen',
                labelButtonRemoveItem: 'entfernen',
                labelButtonAbortItemLoad: 'Abbrechen',
                labelButtonRetryItemLoad: 'Widerholen',
                labelButtonAbortItemProcessing: 'Abbrechen',
                labelButtonUndoItemProcessing: 'Rückgänig machen',
                labelButtonRetryItemProcessing: 'Wiederholen',
                labelMaxFileSizeExceeded: 'Die Datei ist zu groß',
                labelMaxFileSize: 'Max. Dateigröße ist {filesize}',
                labelMaxTotalFileSizeExceeded: 'Die Max. gesamt Dateigröße überschritten',
                labelMaxTotalFileSize: 'Die max. gesamte Dateigröße ist {filesize}',
                allowMultiple: false,
                allowFileEncode: true,
                maxFiles: 1,
                required: false,
                maxParallelUploads: 1,
                instantUpload: false,
                acceptedFileTypes: ['application/pdf'],
                beforeAddFile: (fileItem) => new Promise(resolve => {
                    // Check for password protection
                    let file   = fileItem.file;
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onload = () => {
                        var files = new Blob([reader.result], {type: 'application/pdf'});
                        files.text().then(x => {
                            // is protected
                            if (x.includes('Encrypt') && x.substring(x.lastIndexOf('<<'), x.lastIndexOf('>>')).includes('/Encrypt')) {
                                return resolve(true);
                            } else {
                                let text       = document.createElement('p');
                                text.innerHTML = `Die PDF-Datei ist nicht passwortgeschützt und kann deshalb nicht hochgeladen werden.<br><br>Bitte die PDF-Datei mit einem Kennwort im folgenden Muster verschlüsseln um fortzufahren: Kombination aus den ersten beiden Buchstaben vom Vornamen und Nachnamen des Klienten und dem aktuellen Jahr (z.B. Max Mustermann 2022: MaMu-22)`;
                                text.classList.add('swal-text', 'mb-0', 'mt-0');
                                swal({
                                    title:               'Fehlende Sicherheit',
                                    content:             text,
                                    icon:                'error',
                                    closeOnClickOutside: false,
                                    closeOnEsc:          false,
                                    buttons:             'verstanden'
                                });
                                return resolve(false);
                            }
                        });
                    }
                })
            });
        });
    }
}